/**
 * Route for `advertiser-signup`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserSignupPage } from "../features/advertiser-signup/AdvertiserSignupPage";

export const advertiserSignupRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-signup",
	component: AdvertiserSignupPage,
});

export default advertiserSignupRoute;
